import type { ReactNode } from 'react'
import { Button, Space, Message } from '@arco-design/web-react'
import { IconSave, IconRefresh } from '@arco-design/web-react/icon'
import { formatSaveScopeLabel } from './optionMeta'

interface Props {
  title: ReactNode
  subtitle?: string
  keys: string[]
  onSave: (keys: string[], overrides?: Record<string, string>) => Promise<void | unknown>
  onReload?: () => void
  saving?: boolean
  validate?: () => string | null
  confirmMessage?: string
  hideSave?: boolean
  children: ReactNode
}

export default function SettingCard({
  title,
  subtitle,
  keys,
  onSave,
  onReload,
  saving,
  validate,
  confirmMessage,
  hideSave,
  children,
}: Props) {
  const submit = async () => {
    if (validate) {
      const msg = validate()
      if (msg) {
        Message.error(msg)
        return
      }
    }
    if (confirmMessage && !window.confirm(confirmMessage)) return
    await onSave(keys)
  }

  const extra = (
    <Space>
      {onReload && (
        <Button icon={<IconRefresh />} onClick={onReload} size="small">
          重新加载
        </Button>
      )}
      {!hideSave && (
        <Button type="primary" icon={<IconSave />} loading={saving} onClick={submit} size="small">
          {formatSaveScopeLabel(keys)}
        </Button>
      )}
    </Space>
  )

  return (
    <div className="settings-section mb-3">
      <div className="settings-section-heading">
        <div>
          {title ? <div className="settings-section-title">{title}</div> : null}
          {subtitle ? <div className="settings-section-desc">{subtitle}</div> : null}
        </div>
        <div className="settings-section-extra">{extra}</div>
      </div>
      <div className="settings-section-body">{children}</div>
    </div>
  )
}
